import { render, staticRenderFns } from "./Medias.vue?vue&type=template&id=6ac19992&scoped=true&"
import script from "./Medias.vue?vue&type=script&lang=ts&"
export * from "./Medias.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac19992",
  null
  
)

export default component.exports